"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stepByStepLayouts = void 0;
exports.stepByStepLayouts = [{
        key: 'vertical',
        imgSrc: ''
    }, {
        key: 'horizontal',
        imgSrc: ''
    }];
